import { AfterViewInit, ChangeDetectorRef, Component, inject, input, ViewChild } from '@angular/core';
import { PaginatorComponent } from '@shared/components/paginator/paginator.component';
import { LatestNewsSectionComponent } from '../home/components/latest-news-section/latest-news-section.component';
import { SectionTemplateComponent } from '@templates/section-template/section-template.component';
import { LinksSectionComponent } from '@shared/components/links-section/links-section.component';
import { SideNavigationComponent } from '@shared/components/side-navigation/side-navigation.component';
import { INews_Response } from '@shared/constants/models.const';
import { BreadcrumbsComponent } from '@shared/components/breadcrumbs/breadcrumbs.component';
import { ThreeColumnTemplateComponent } from '@templates/three-column-template/three-column-template.component';
import { CkViewerComponent } from '@shared/components/ck-viewer/ck-viewer.component';
import { SelectCategoryComponent } from '../home/components/select-category/select-category.component';
import { TranslateModule } from '@ngx-translate/core';
import { TocComponent } from '@shared/components/toc/toc.component';
import { HelperService } from '../../services/helper.service';
import { DefaultPortletsComponent } from '@shared/components/default-portlets/default-portlets.component';
import { CollectionsComponent } from '@shared/components/collections/collections.component';

@Component({
  selector: 'app-news',
  imports: [
    PaginatorComponent,
    LatestNewsSectionComponent,
    SectionTemplateComponent,
    LinksSectionComponent,
    SideNavigationComponent,
    BreadcrumbsComponent,
    ThreeColumnTemplateComponent,
    CkViewerComponent,
    SelectCategoryComponent,
    TranslateModule,
    TocComponent,
    DefaultPortletsComponent,
    CollectionsComponent,

  ],
  templateUrl: './news.component.html',
  styleUrl: './news.component.scss',
})
export class NewsComponent implements AfterViewInit {
  pageData = input<INews_Response | any>();
  @ViewChild(SelectCategoryComponent) SelectCategory!: SelectCategoryComponent;

  readonly cd: ChangeDetectorRef = inject(ChangeDetectorRef);
  readonly HELPER = inject(HelperService);

  get isStickyVisible() {
    return this.HELPER.selectCategoryStickyState;
  }

  ngAfterViewInit() {
    this.HELPER.selectCategoryHandle(this.SelectCategory);
  }


}
